import { Injectable } from '@angular/core';
import { ReadingModel } from '../_models/ReadingModel';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { AlertifyService } from '../_services/alertify.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ExamService } from '../_services/exam.service';

@Injectable()
export class ListReadingsResolver implements Resolve<ReadingModel[]> {
    constructor(private examService: ExamService, private router: Router,
                private alertify: AlertifyService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<ReadingModel[]> {
        return this.examService.getReadings().pipe(
            catchError(error => {
                this.alertify.error('problem retriving data');
                this.router.navigate(['/home']);
                return of(null);
            })
        );
    }
}